import Splide from '@splidejs/splide';

const EL = '.js-text-carousel';

const shuffleSlides = (carousel) => {
  const list = carousel.querySelector('.splide__list');
  if (!list) return;

  const slides = Array.from(list.children);

  // Fisher-Yates - runs client-side so the order still varies per page view
  // even when the rendered HTML itself is page-cached.
  for (let i = slides.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [slides[i], slides[j]] = [slides[j], slides[i]];
  }

  slides.forEach((slide) => list.appendChild(slide));
};

document.querySelectorAll('.js-text-carousel').forEach((carousel) => {
  if (carousel.dataset.shuffle === '1') {
    shuffleSlides(carousel);
  }

  const slider = new Splide(carousel, {
    arrows: false,
    pagination: false,
    gap: 20,
    autoWidth: true,
    breakpoints: {
      1366: {

      },
      1024: {

      },
      767: {

      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');
  const progressBar = carousel.querySelector('.splide__progress__bar');


  const updateControls = () => {
    const isLoop = slider.options.type === 'loop';
    const endIndex = slider.Components.Controller.getEnd();

    if (!isLoop) {
      if (prevButton) prevButton.disabled = slider.index === 0;
      if (nextButton) nextButton.disabled = slider.index >= endIndex;
    } else {
      if (prevButton) prevButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
    }
  };

  const updateProgress = () => {
    if (!progressBar) return;
    const track = carousel.querySelector('.splide__track');
    if (!track) return;

    const trackWidth = track.clientWidth;
    const slides = carousel.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    const slideCount = slides.length;
    if (!slideCount) return;

    const slideWidth = slides[0].offsetWidth;
    const gap = slider.options.gap || 0;
    const slideStep = slideWidth + gap;
    const totalWidth = slideCount * slideStep;

    const isLoop = slider.options.type === 'loop';

    if (isLoop) {
      const ratio = Math.min(trackWidth / totalWidth, 1);
      const denom = Math.max(slideCount - 1, 1);
      const tx = (slider.index / denom) * (1 - ratio) / Math.max(ratio, 0.0001) * 100;
      progressBar.style.width = `${ratio * 100}%`;
      progressBar.style.transform = `translateX(${tx}%)`;
      return;
    }

    const list = carousel.querySelector('.splide__list');
    if (!list) return;
    const listWidth = list.scrollWidth;

    if (listWidth <= trackWidth) {
      progressBar.style.width = '100%';
      progressBar.style.transform = 'translateX(0)';
      return;
    }

    const ratio = trackWidth / listWidth;
    const position = Math.abs(slider.Components.Move.getPosition());
    const maxPosition = listWidth - trackWidth;
    const progress = Math.min(position / maxPosition, 1);

    progressBar.style.width = `${ratio * 100}%`;
    progressBar.style.transform = `translateX(${progress * (100 / ratio - 100)}%)`;
  };


  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  slider.on('moved', () => {
    updateControls();
    updateProgress();
  });
  slider.on('resized', updateProgress);

  updateControls();
  updateProgress();
});
